import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconLibraryBooks.tsx
const OutlinedFilledLibraryBooks = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M348-424h237v-69H348v69Zm0-99h420v-69H348v69Zm0-99h420v-69H348v69Zm-62 430q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-636h95v636h636v95H132Z" })
});
const OutlinedLibraryBooks = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M348-424h237v-69H348v69Zm0-99h420v-69H348v69Zm0-99h420v-69H348v69Zm-62 430q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286Zm0-94h542v-542H286v542ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-636h95v636h636v95H132Zm154-791v542-542Z" })
});
const RoundedFilledLibraryBooks = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M381.82-424H551q13.9 0 23.95-10.1Q585-444.2 585-458.18q0-14.4-10.05-24.61Q564.9-493 551-493H381.82q-14.57 0-24.19 10.27-9.63 10.27-9.63 24.5t9.63 24.23q9.62 10 24.19 10Zm-.15-99H734q13.9 0 23.95-10.1Q768-543.2 768-557.18q0-14.4-10.05-24.61Q747.9-592 734-592H381.67q-14.42 0-24.04 10.27-9.63 10.27-9.63 24.5t9.63 24.23q9.62 10 24.04 10Zm0-99H734q13.9 0 23.95-10.1Q768-642.2 768-656.18q0-14.4-10.05-24.61Q747.9-691 734-691H381.67q-14.42 0-24.04 10.27-9.63 10.27-9.63 24.5t9.63 24.23q9.62 10 24.04 10ZM286-192q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-589q0-19.75 13.68-33.38Q64.35-768 84.68-768q20.32 0 33.82 13.62Q132-740.75 132-721v589h589q19.75 0 33.38 13.68 13.62 13.67 13.62 34Q768-64 754.38-50.5 740.75-37 721-37H132Z" })
});
const RoundedLibraryBooks = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M381.82-424H551q13.9 0 23.95-10.1Q585-444.2 585-458.18q0-14.4-10.05-24.61Q564.9-493 551-493H381.82q-14.57 0-24.19 10.27-9.63 10.27-9.63 24.5t9.63 24.23q9.62 10 24.19 10Zm-.54-99h353.11q13.51 0 23.56-10.1Q768-543.2 768-557.18q0-14.4-10.05-24.61Q747.9-592 734.39-592H381.28q-14.03 0-23.65 10.27-9.63 10.27-9.63 24.5t9.63 24.23q9.62 10 23.65 10Zm0-99h353.11q13.51 0 23.56-10.1Q768-642.2 768-656.18q0-14.4-10.05-24.61Q747.9-691 734.39-691H381.28q-14.03 0-23.65 10.27-9.63 10.27-9.63 24.5t9.63 24.23q9.62 10 23.65 10ZM286-192q-39.05 0-66.52-27.48Q192-246.95 192-286v-542q0-39.46 27.48-67.23Q246.95-923 286-923h542q39.46 0 67.23 27.77Q923-867.46 923-828v542q0 39.05-27.77 66.52Q867.46-192 828-192H286Zm0-94h542v-542H286v542ZM132-37q-39.46 0-67.23-27.77Q37-92.54 37-132v-589q0-19.75 13.68-33.38Q64.35-768 84.68-768q20.32 0 33.82 13.62Q132-740.75 132-721v589h589q19.75 0 33.38 13.68 13.62 13.67 13.62 34Q768-64 754.38-50.5 740.75-37 721-37H132Zm154-791v542-542Z" })
});
const SharpFilledLibraryBooks = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M348-424h237v-69H348v69Zm0-99h420v-69H348v69Zm0-99h420v-69H348v69ZM192-192v-731h731v731H192ZM37-37v-731h95v636h636v95H37Z" })
});
const SharpLibraryBooks = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M348-424h237v-69H348v69Zm0-99h420v-69H348v69Zm0-99h420v-69H348v69ZM192-192v-731h731v731H192Zm94-94h542v-542H286v542ZM37-37v-731h95v636h636v95H37Zm249-791v542-542Z" })
});
const componentMap = {
	outlined: OutlinedLibraryBooks,
	"outlined-fill": OutlinedFilledLibraryBooks,
	rounded: RoundedLibraryBooks,
	"rounded-fill": RoundedFilledLibraryBooks,
	sharp: SharpLibraryBooks,
	"sharp-fill": SharpFilledLibraryBooks
};
const IconLibraryBooks = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconLibraryBooks };